module.exports = __webpack_public_path__ + "img/004-owl.ac854839.svg";